import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uk-container" }
const _hoisted_2 = { class: "uk-table uk-table-striped uk-table-hover uk-table-divider uk-box-shadow-small" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "uk-text-left" }
const _hoisted_5 = { class: "uk-text-left" }
const _hoisted_6 = { class: "uk-text-left" }
const _hoisted_7 = { class: "uk-text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, "Welcome to the " + _toDisplayString(_ctx.cityName) + " directory!", 1),
    _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "uk-margin-remove" }, "This is a community effort to better discover and find all the great carriers in the Oakland area", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Click on a company below to see more information about them", -1)),
    _createElementVNode("table", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
        _createElementVNode("th", null, "Company Name"),
        _createElementVNode("th", null, "Address"),
        _createElementVNode("th", null, "Email"),
        _createElementVNode("th", null, "Phone")
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companiesList, (company) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: company.id,
            class: "uk-box-shadow-hover-small",
            onClick: ($event: any) => (_ctx.navigateToCompanyDirectoryInfoPage(company.id))
          }, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(company.name), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.fullAddress(company.officeAddress)), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(company.email), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(company.phoneNumber), 1)
          ], 8, _hoisted_3))
        }), 128))
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("a", {
      class: "uk-button uk-button-secondary",
      href: "mailto:directory@contrak.us?subject=Add to directory request&body=Hi, my company name is: %0d%0a%0d%0aOur company description is: %0d%0a%0d%0aOur services offered are: %0d%0a%0d%0a"
    }, "Add my company to the directory", -1))
  ]))
}